import { Typography, styled, Button as ButtonMui } from "@mui/material"

export const SubTitle = styled(Typography)({
  fontSize: "1.25rem",
  color: "#757575",
  width: "100%",
})

export const Image = styled("img")({
  width: "100%",
  maxWidth: "250px",
  margin: "3rem auto 3rem auto",
})

export const Button = styled(ButtonMui)(({ theme, disabled }) => ({
  color: "#fff",
  fontWeight: 500,
  borderRadius: "16px",
}))
